import { mockCoursesResponse } from '../mock/mock-courses.js';
import { fetchGalleryData } from '../services/api-service.js';
import '../mappers/simple.mapper.js';
import '../mappers/courses.mapper.js';
import { getMapper } from '../mappers/register.js';
import { debounce, normalizeSearchValue, normalizeSelectValue } from './events.js';
import { getCountryFromUrl } from './locale.js';

class CardGalleryStateController {
    constructor(host) {
        this.host = host;
        this.country = getCountryFromUrl();
        this.debouncedSearch = debounce(() => {
            this.loadData();
        }, 500);
    }
    initialize() {
        this.loadData();
    }
    resolveMapper() {
        const mapperFn = getMapper(this.host.mapper);
        if (typeof mapperFn === 'function') {
            return mapperFn;
        }
        return (item) => {
            var _a;
            return ({
                title: (_a = item === null || item === void 0 ? void 0 : item.title) !== null && _a !== void 0 ? _a : '',
            });
        };
    }
    filterMockItems(rawItems) {
        var _a, _b;
        const search = (_b = (_a = this.host.search) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const selectedCategory = this.host.selectedA;
        const selectedTag = this.host.selectedB;
        return rawItems.filter(item => {
            var _a, _b, _c;
            const anyItem = item;
            const title = String((_a = anyItem.title) !== null && _a !== void 0 ? _a : '').toLowerCase();
            const description = String((_b = anyItem.description) !== null && _b !== void 0 ? _b : '').toLowerCase();
            const categoryName = String((_c = anyItem.categoryName) !== null && _c !== void 0 ? _c : '');
            const tags = Array.isArray(anyItem.tags) ? anyItem.tags : [];
            const matchesSearch = !search || title.includes(search) || description.includes(search);
            const matchesCategory = !selectedCategory || categoryName === selectedCategory;
            const matchesTag = !selectedTag || tags.includes(selectedTag);
            return matchesSearch && matchesCategory && matchesTag;
        });
    }
    paginateItems(filteredItems) {
        const pageSizeNumber = Number(this.host.pageSize) || 1;
        const currentPage = Number(this.host.page) || 1;
        const startIndex = (currentPage - 1) * pageSizeNumber;
        const endIndex = startIndex + pageSizeNumber;
        return filteredItems.slice(startIndex, endIndex);
    }
    async loadData() {
        this.host.isLoading = true;
        try {
            const mapperFn = this.resolveMapper();
            if (!this.host.endpoint) {
                const allItems = Array.isArray(mockCoursesResponse.items)
                    ? mockCoursesResponse.items
                    : [];
                const filteredItems = this.filterMockItems(allItems);
                const pagedItems = this.paginateItems(filteredItems);
                this.host.items = pagedItems.map(item => mapperFn(item));
                this.host.totalItems = filteredItems.length;
                return;
            }
            const data = await fetchGalleryData({
                endpoint: this.host.endpoint,
                page: this.host.page,
                pageSize: this.host.pageSize,
                search: this.host.search,
                filterA: this.host.selectedA,
                filterB: this.host.selectedB,
                headers: this.host.requestHeaders,
                country: this.country,
            });
            this.host.items = data.items.map(item => mapperFn(item));
            this.host.totalItems = data.totalItems;
        }
        finally {
            this.host.isLoading = false;
        }
    }
    updateSearch(value) {
        this.host.search = normalizeSearchValue(value);
        this.host.page = 1;
        this.debouncedSearch();
    }
    updateSelectA(value) {
        this.host.selectedA = normalizeSelectValue(value);
        this.host.page = 1;
        this.loadData();
    }
    updateSelectB(value) {
        this.host.selectedB = normalizeSelectValue(value);
        this.host.page = 1;
        this.loadData();
    }
    goToPage(value) {
        this.host.page = value;
        this.loadData();
    }
}

export { CardGalleryStateController };
